import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  ViewChild,
  ElementRef,
  Output,
} from "@angular/core";

import { ViewfileComponent } from "src/app/components/viewfile/viewfile.component";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { SearchTypeModel } from "src/app/Models/AttachmentInfo.model";
import { ProjectService } from "../projects/services/projectservice.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SearchPageService } from "../searchpage/searchpage.service";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
declare var $: any;
import { AuthServiceService } from "src/app/services/auth-service.service";
import { EventEmitter } from "@angular/core";
import { GraphService } from "src/app/services/Organization/graph.service";
import { EmployeeInfo } from "src/app/Models/employeeInfo.model";
import { EmployeeService } from "./employee-profile.service";
import { EditEmployeeComponent } from "src/app/views/edit-employee/edit-employee.component";
import { EmailFileModel, FileInfoModel } from "src/app/Models";
@Component({
  selector: "app-employee-profile",
  templateUrl: "./employee-profile.component.html",
  styleUrls: ["./employee-profile.component.css"],
})
export class EmployeeProfileComponent implements OnInit {
  @Input() projectsView: string;
  @Input() search: string;
  @Input() noHeader: boolean;
  @Input() filterValues: any;
  @Output() demo = new EventEmitter();

  public searchResults: EmployeeInfo[];
  public loading = false;
  public getSelectedFileRequests = [];
  public groupedSearchResults: any[] = [];
  public selectedFiles = [];
  public overflow = false;
  public attachedIds = [];
  public role: string;
  private searchConfig: SearchTypeModel;

  @ViewChild("attachmentId") attachmentId: ElementRef;
  @ViewChild("closeId") closeId: ElementRef;
  @ViewChild("actions") actions: ElementRef;

  public mailMultipleAttachments: string[];
  public selectAllDivFlag: boolean;
  public searchResultsViewFlag: boolean;
  groupSearchFlag = false;

  organizationId: string;
  organizationName: string;
  organizations: any[] = [];
  specialityList: any;
  restrictDownloadAndMail: boolean;

  from = 0;
  size = 12;
  maxProfiles = 12;
  api = "";
  finalParam: any;
  apiLookup = {
    sme: "getAllSMEs",
    certified: "getAllCertifiedResources",
    available: "getAllAvailableResources",
    "pending-certifications": "getAllCertificationInProgressResources",
    competency: "getAvailableProfilesbyCompetencyId",
    search: "getEmployees",
  };
  dataSource = new MatTableDataSource<EmployeeInfo>();

  employeeData: any;

  showSearchRelevancy: boolean = false;

  noDataFound: boolean = false;

  constructor(
    private graphService: GraphService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private projectService: ProjectService,
    private searchPageService: SearchPageService,
    private auth: AuthServiceService,
    private employeeService: EmployeeService,
    private route: ActivatedRoute
  ) {
    this.role = this.auth.getRole();
    this.restrictDownloadAndMail = this.auth.getDownloadAndMailRestriction();
    this.mailMultipleAttachments = new Array<string>();
    this.searchConfig = new SearchTypeModel();
    $('[data-toggle="popover"]').popover();
    $(function () {
      $('[data-toggle="popover"]').popover();
    });
  }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe((res) => {
      this.api = "search";
      this.finalParam = "Kiran Mirdoddi";
      this.setEmployeesData();
    });
  }

  ngOnChanges() {
    //uncomment following for searching only if there are 3 or more characters
    if (this.search) {
      this.api = "search";
      this.finalParam = this.search;
    }
    this.setEmployeesData();
  }

  setEmployeesData() {
    this.from = 0;
    if (this.search) {
      this.showSearchRelevancy = true;
    } else {
      this.showSearchRelevancy = false;
    }

    if (this.employeeService && this.employeeService[this.apiLookup[this.api]])
      this.employeeService[this.apiLookup[this.api]](
        this.from,
        this.size,
        this.finalParam
      ).subscribe((res) => {
        this.employeeData = res;
        this.maxProfiles = res.data.total;
        this.bindResults(this.employeeData);
        this.loading = false;
      });
  }

  onScroll() {
    if (this.search) {
      this.showSearchRelevancy = true;
    } else {
      this.showSearchRelevancy = false;
    }
    this.from = this.from + this.size;
    if (this.from <= this.maxProfiles) {
      this.size = this.size;
      this.search = this.search;
      if (
        this.employeeService &&
        this.employeeService[this.apiLookup[this.api]]
      )
        this.employeeService[this.apiLookup[this.api]](
          this.from,
          this.size,
          this.finalParam
        ).subscribe((res: any) => {
          this.maxProfiles = res.data.total;
          var x = res.data.profiles as Array<EmployeeInfo>;
          x.forEach((element) => {
            this.employeeData.data.profiles.push(element);
          });
          this.bindResults(this.employeeData);
        });
    }
  }

  downloadFile(attachment, type) {
    this.loading = true;
    let documentId =
      type == "tcs" ? attachment.iFrameURL : attachment.businessiFrameURL;
    if (documentId) {
      this.graphService.getDownloadUrl(documentId).subscribe(
        (response) => {
          if (response) {
            const link = document.createElement("a");
            link.setAttribute("type", "hidden");
            link.href = response.url;
            link.download = attachment.attachmentName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.loading = false;
            this.updateDownloadCount(attachment);
          } else {
            this.loading = false;
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              width: "350px",
              data: {
                message:
                  "Could not download the file. Please try again after some time or contact administrator",
                class: "text-danger",
              },
            });
          }
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "350px",
            data: {
              message:
                "Could not download the file. Please try again after some time or contact administrator",
              class: "text-danger",
            },
          });
        }
      );
    }
  }

  updateDownloadCount(attachment) {
    this.projectService.updateDownloadCount(attachment.id).subscribe(
      (res) => {
        if (res) {
          attachment.downloadCount = attachment.downloadCount + 1;
        } else {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "350px",
            data: {
              message:
                "Could not update the Download Count. Please try again after some time",
              class: "text-danger",
            },
          });
        }
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "350px",
          data: {
            message:
              "Could not update the Download Count. Please try again after some time or contact administrator",
            class: "text-danger",
          },
        });
      }
    );
  }

  bindResults(res) {
    this.searchResults = [];
    this.loading = false;
    for (let index = 0; index < res.data.total; index++) {
      const result = res.data.profiles[index];
      if (result) {
        const employeeInfo = this.prepareEmployeeInfo(result);
        this.searchResults.push(employeeInfo);
      }
    }
    this.searchResultsViewFlag = true;
    this.groupSearchFlag = false;
    if (!res.data || (res.data && !res.data.total)) {
      this.noDataFound = true;
    }
  }

  editEmployee(val: string) {
    const dialogRef = this.dialog.open(EditEmployeeComponent, {
      width: "500px",
      data: val,
    });
  }

  viewFile(attachment, type) {
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: {
        iFrameURL:
          type == "tcs" ? attachment.iFrameURL : attachment.businessiFrameURL,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.projectService.updateViewCount(attachment.id).subscribe(
        (res) => {
          if (res) {
            attachment.viewCount = attachment.viewCount + 1;
          } else {
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              width: "350px",
              data: {
                message:
                  "Could not update the View Count. Please try again after some time",
                class: "text-danger",
              },
            });
          }
        },
        (err) => {
          this.loading = false;
        }
      );
    });
  }

  prepareEmployeeInfo(result) {
    const employeeInfo = new EmployeeInfo();
    employeeInfo.employeeId = result.employeeId;
    employeeInfo.firstName = result.firstName;
    employeeInfo.lastName = result.lastName;
    employeeInfo.grade = result.grade;
    employeeInfo.project = result.project;
    employeeInfo.isProjectAllocated = result.isProjectAllocated;
    employeeInfo.isCertified = result.isCertified;
    employeeInfo.expertises = result.expertises;
    employeeInfo.experience = result.experience == null ? 0 : result.experience;
    employeeInfo.skill = result.skill;
    employeeInfo.managerEmpCode = result.managerEmpCode;
    employeeInfo.location = result.location;
    employeeInfo.isSME = result.isSME;
    employeeInfo.smEs = result.smEs;
    employeeInfo.managerFirstName = result.managerFirstName;
    employeeInfo.managerLastName = result.managerLastName;
    employeeInfo.competencyName = result.competencyName;
    employeeInfo.tagCloud = result.tagCloud;
    employeeInfo.score = result.score;

    return employeeInfo;
  }
  openResume(employeeId: any) {
    this.employeeService.fetchResume(employeeId).subscribe((res) => {
      const byteArray = new Uint8Array(
        atob(res.data)
          .split("")
          .map((char) => char.charCodeAt(0))
      );
      let blob = new Blob([byteArray], { type: "application/pdf" }); //make it generic
      const url = window.URL.createObjectURL(blob);
      const dialogRef = this.dialog.open(ViewfileComponent, {
        width: "900px",
        height: "500px",
        panelClass: "view-file",
        data: { iFrameURL: url },
      });
    });
  }
  downloadResume(employeeId: any) {
    this.employeeService.fetchResume(employeeId).subscribe((res) => {
      var result = res.data;
      var a = document.createElement("a");
      a.href = result.Extention + result.Data;
      a.download = result.Name; //File name Here
      a.click();
      a.remove();
    });
  }
  selectProfile(attachment: EmployeeInfo) { }

  searchDoc(getSearchOptions: SearchTypeModel) {
    this.searchConfig.searchTerm = getSearchOptions.searchTerm;
    this.searchConfig.filterList = getSearchOptions.filterList;
    this.searchConfig.groupBy = getSearchOptions.groupBy;
    this.searchConfig.operator = getSearchOptions.operator;
    this.searchConfig.activeProjectsFilter =
      getSearchOptions.activeProjectsFilter;
    this.searchConfig.displayType = getSearchOptions.displayType;
    this.loading = true;
    this.mailMultipleAttachments = [];
    this.selectedFiles = [];

    this.searchResults = [];
    this.groupedSearchResults = [];
    this.projectService.searchDoc(this.searchConfig).subscribe(
      (res) => {
        const results = res;
        if (results.length > 0) {
          this.searchResultsViewFlag = true;
          window.scroll(0, 0);
          this.selectAllDivFlag = true;
          $("#main").addClass("searchanim");
          $(".bgimg-2").addClass("fade");
          $(".title").addClass("titletoggle");
          setTimeout(function () {
            $("#main").addClass("reset").removeClass("searchanim");
            $("#mainheader").addClass("headerstyle");
            $(".cards_box").addClass("d-block");
          }, 600);
          if (this.searchConfig.groupBy) {
            for (let index = 0; index < res.length; index++) {
              const groupByResult = res[index];
              if (groupByResult) {
                const groupByAttachment = {
                  groupBy: groupByResult.key,
                  attachments: [],
                };
                const results = groupByResult.results;
                if (results.length > 0) {
                  this.searchResults = [];
                  for (let index = 0; index < results.length; index++) {
                    const result = results[index];
                    if (result) {
                      const attachmentInfo = this.prepareEmployeeInfo(result);
                      groupByAttachment.attachments.push(attachmentInfo);
                    }
                  }
                }
                this.groupedSearchResults.push(groupByAttachment);
                this.groupSearchFlag = true;
              }
            }
            this.cd.detectChanges();
          } else {
            this.searchResults = [];
            for (let index = 0; index < results.length; index++) {
              const result = results[index];
              if (result) {
                const attachmentInfo = this.prepareEmployeeInfo(result);
                this.searchResults.push(attachmentInfo);
              }
            }
            this.groupSearchFlag = false;
            this.cd.detectChanges();
          }
        } else {
          this.searchResults = [];
          this.selectAllDivFlag = false;
          this.searchResultsViewFlag = true;
          this.searchPageService.filterButtonFlag = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: "No files found!", class: "text-danger" },
          });
        }
        this.loading = false;
        this.cd.detectChanges();
      },
      (error) => {
        this.selectAllDivFlag = false;
        this.searchResultsViewFlag = false;
        this.searchPageService.filterButtonFlag = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "No files found!", class: "text-danger" },
        });
        this.loading = false;
      }
    );
    this.cd.detectChanges();
  }

  sendMail(attachment: any, multipleCheck: string) {
    const mailOptions = new EmailFileModel(this.auth.getEmailId());
    if (multipleCheck === "single") {
      const selectedMailFile = new FileInfoModel(
        attachment.iFrameURL,
        attachment.attachmentName,
        attachment.deliveryOrganization
      );
      mailOptions.fileInfo.push(selectedMailFile);
    } else {
      this.selectedFiles.forEach((selectedFile) => {
        const selectedMailFile = new FileInfoModel(
          selectedFile.iFrameURL,
          selectedFile.attachmentName,
          selectedFile.deliveryOrganization
        );
        mailOptions.fileInfo.push(selectedMailFile);
      });
    }

    this.loading = true;
    this.graphService.sendEmail(mailOptions).subscribe(
      (res) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message: "E-mail sent successfully.",
            class: "text-success",
          },
        });
      },
      (err) => {
        this.loading = false;
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: {
            message: "Some Error has occurred" + err.message,
            class: "text-danger",
          },
        });
      }
    );
  }
}
